export type QuotePart = {
  text: string;
  emphasis: boolean;
};

/**
 * Converte o depoimento numa lista de pedaços, marcando o que estiver entre
 * asteriscos para sair grifado no recado — marca-texto na cor do papel.
 *
 * O admin digita `...e *eu durmo de noite.*`. Só existe esse marcador — sem
 * aninhamento, sem negrito, sem link. Asterisco que não fecha vira texto
 * literal, então um erro de digitação nunca engole o resto da frase.
 *
 * Devolve dados, não HTML: quem renderiza monta `<span>` no JSX. Nada de
 * `dangerouslySetInnerHTML` com texto que veio do banco.
 */
export const parseQuoteEmphasis = (quote: string): QuotePart[] => {
  if (!quote) {
    return [];
  }

  const partes: QuotePart[] = [];
  let buffer = "";
  let cursor = 0;

  const empurrar = (text: string, emphasis: boolean) => {
    if (!text) return;
    const anterior = partes[partes.length - 1];
    // Junta com o pedaço anterior quando os dois são texto normal, para um par
    // vazio não deixar dois pedaços colados na lista.
    if (anterior && !anterior.emphasis && !emphasis) {
      anterior.text += text;
      return;
    }
    partes.push({ text, emphasis });
  };

  while (cursor < quote.length) {
    const abertura = quote.indexOf("*", cursor);

    if (abertura === -1) {
      buffer += quote.slice(cursor);
      break;
    }

    const fechamento = quote.indexOf("*", abertura + 1);

    if (fechamento === -1) {
      // Asterisco solto: o resto da frase é texto normal, inclusive ele.
      buffer += quote.slice(cursor);
      break;
    }

    buffer += quote.slice(cursor, abertura);
    empurrar(buffer, false);
    buffer = "";

    empurrar(quote.slice(abertura + 1, fechamento), true);
    cursor = fechamento + 1;
  }

  empurrar(buffer, false);

  return partes;
};
